<template>
  <identification-details
    complianceReviewIdentificationId="complianceReviewIdentificationId"
  />
</template>
<script>
import IdentificationDetails from "@/components/IdentificationDetails";
import { mapActions, mapMutations } from "vuex";
import { actions } from "@/store";
import { mapGetters } from "vuex";
import { getters } from "@/store";

export default {
  components: { IdentificationDetails },
  mounted() {
    this.getComplianceReviewItem({
      id: this.complianceReviewId
    });
    this.$store.commit("initIdentification", {
      identificationId: this.complianceReviewIdentificationId
    });
    this.getIdentification({
      identificationId: this.complianceReviewIdentificationId
    });
    this.$store.commit("workSetIdentification", {
      identificationId: this.complianceReviewIdentificationId
    });
  },
  computed: {
    ...mapGetters([getters.identificationUpdating]),
    complianceReviewId() {
      return this.$route.query.id;
    },
    complianceReviewIdentificationId() {
      return this.$route.query.identificationId;
    }
  },
  methods: {
    ...mapActions([actions.getIdentification, actions.getComplianceReviewItem]),
    ...mapMutations({
      initIdentification: "initIdentification",
      workSetIdentification: "workSetIdentification"
    })
  }
};
</script>
<style scoped>
.loader-container {
  max-width: 110rem;
  margin: 0 auto;
}
</style>
